<template>
  <div class="relative inline-block z-10 border-solid border border-soft rounded" :class="pickerOpen ? 'section-picker-open' : 'section-picker-closed'" v-on-clickaway="close">
    <div>
      <button type="button" @click="toggle" class="test-section-picker border-none inline-flex w-full bg-white cursor-pointer text-gray-dark active:text-black-soft">
        <vs-icon class="p-3 m-3 border-solid border rounded border-primary" :icon="pickerOpen ? 'clear' : 'add'" color="primary" />
        <span class="ml-2 my-auto text-base text-left">{{pickerTitle}}<br/> <span class="text-gray text-sm">{{pickerSubtitle}}</span></span>
      </button>
    </div>

    <div v-if="pickerOpen" class="origin-top-right absolute right-0 w-full rounded-md z-10 border border-solid border-soft rounded-b section-picker-menu">
      <div class="rounded-md bg-white">
        <div class="py-1">
          <section-picker-item v-for="(item, i) in pickerItems" :key="i"
            :title="item.title" :icon="item.icon" @click="item.onClick" :disabled="item.disabled()" :disabled-hint="item.disabledHint" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import SectionPickerItem from './SectionPickerItem'

export default {
  name: 'SectionPicker',

  props: {
    titleOpen: {
      type: String,
      required: true
    },
    titleClosed: {
      type: String,
      required: true
    },
    subtitleOpen: {
      type: String,
      default: ''
    },
    subtitleClosed: {
      type: String,
      default: ''
    },
    pickerItems: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      pickerOpen: false
    }
  },

  components: {
    SectionPickerItem
  },

  directives: {
    onClickaway: onClickaway
  },

  computed: {
    pickerTitle() {
      return this.pickerOpen ? this.titleOpen : this.titleClosed
    },

    pickerSubtitle() {
      return this.pickerOpen ? this.subtitleOpen : this.subtitleClosed
    }
  },

  methods: {
    sortPickerItems() {
      // first put all disabled items to the bottom
      // eslint-disable-next-line
        this.pickerItems.sort((e1, e2) => {
        if(e1.disabled()) return 1

        return -1
      })

      // then sort both the enabled and the disabled groups to the preferred order
      this.pickerItems.sort((e1, e2) => {
        if(e1.disabled() === e2.disabled()) {
          return e1.order - e2.order
        }

        return 0
      })
    },

    toggle() {
      this.pickerOpen = !this.pickerOpen

      if(this.pickerOpen) {
        this.sortPickerItems()
      }
    },

    close() {
      this.pickerOpen = false
    }
  }
}
</script>

<style scoped lang="scss">

  .section-picker-closed, .section-picker-menu {
    // noinspection CssInvalidFunction - theme() belongs to TailWind
    box-shadow: 0px 10px 30px theme('colors.gray-a10') !important;
  }

  .section-picker-open {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

</style>
